import axios from "axios";

const getConfiguracionTesoreria = async () => {
  const formattedNic = localStorage.getItem("formattedNic");
  const token = localStorage.getItem("token");

  const userData = {
    nic: formattedNic,
    token: token,
    serialNumberKeyClover: localStorage.getItem("serialNumberKeyClover"),
  };
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Helper/GetConfiguracionTesoreria`, userData);
  return response.data;
};

const configuracionTesoreria = {
  getConfiguracionTesoreria,
};

export default configuracionTesoreria;
